module.exports = __webpack_public_path__ + "img/5.8ae6b6ec.gif";